module.exports = __webpack_public_path__ + "static/images/eva-empty.3bcd169.png";